module.exports = __webpack_public_path__ + "img/kistimldms_04.0157bca2.png";